/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

// Framework dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { useNativeWebBackNavigation } from '@updater/native-web';
// Core dependencies
import useIsViewportSize from '@updater-core/uds/hooks/is-viewport';

// Local dependencies
import classes from './index.module.css';
import CircularProgress from '../CircularProgress';

function BackArrow({ color }) {
  return (
    <svg
      width="12"
      height="23"
      viewBox="0 0 12 23"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.493965 10.8819C0.726787 10.6491 1.10427 10.6491 1.33709 10.8819L11.2252 20.77C11.458 21.0028 11.458 21.3803 11.2252 21.6131C10.9924 21.8459 10.6149 21.8459 10.3821 21.6131L0.493965 11.725C0.261142 11.4922 0.261142 11.1147 0.493965 10.8819Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8035 0.921577C11.0364 1.1544 11.0364 1.53188 10.8035 1.7647L1.26467 11.3036C1.03185 11.5364 0.654365 11.5364 0.421543 11.3036C0.18872 11.0707 0.188721 10.6933 0.421543 10.4604L9.96041 0.921577C10.1932 0.688755 10.5707 0.688755 10.8035 0.921577Z"
      />
    </svg>
  );
}

function BackButton({ color, onClick }) {
  const navigateBack = useNativeWebBackNavigation(onClick);

  return (
    <div
      className={classes.backArrow}
      onClick={navigateBack}
      alt="Back Arrow"
      data-cy="back"
    >
      <BackArrow color={color} />
    </div>
  );
}

function ProgressHeader({
  animateFromLast,
  backArrowColor = 'black',
  className = '',
  largeHeader = false,
  onBack,
  progress,
  title,
  totalSteps = 4,
}) {
  const { isLarge } = useIsViewportSize();

  let headerClassName = classes.header;
  let headerTextClassName = classes.headerText;

  if (largeHeader) {
    if (isLarge) {
      headerTextClassName = classes.largerHeaderText;
    } else {
      headerTextClassName = classes.largeHeaderText;
    }
    headerClassName = classes.headerVariation;
  }

  return (
    <div className={`${headerClassName} ${className}`}>
      {onBack && <BackButton color={backArrowColor} onClick={onBack} />}
      {!onBack && <div className={classes.backArrow} />}
      <div data-name="progress-header-text" className={headerTextClassName}>
        {title}
      </div>
      {progress && (
        <CircularProgress
          className={classes.progress}
          currentStep={progress}
          stepCount={totalSteps}
          animateFromLast={animateFromLast}
        />
      )}
      {!progress && <div className={classes.progress} />}
    </div>
  );
}

ProgressHeader.propTypes = {
  onBack: PropTypes.func,
  title: PropTypes.string,
  backArrowColor: PropTypes.string,
  progress: PropTypes.number,
  totalSteps: PropTypes.number,
  animateFromLast: PropTypes.bool,
};

export default ProgressHeader;
